import React from 'react'
import { connect } from 'react-redux'
import { getMessagesById } from '../../../services/messages'
import EmptyScreen from '../EmptyScreen'
import './styles.scss'

function ChatArea ({ id, title }) {
  const data = getMessagesById(id)

  if (!id) return <EmptyScreen />

  return (
    <div className='chatArea'>
      <header className='chatArea__header'>#{title}</header>
      <div className='chatArea__messages'>
        {data.map(item => (
          <div className='chatArea__message' key={item.id}>
            <h3 className='chatArea__nickname'>
              {item.user.username}
              <span className='chatArea__hour'>{item.timestamp}</span>
            </h3>
            <p>{item.content}</p>
          </div>
        ))}
      </div>
      <footer className='chatArea__footer'>
        <form onSubmit={e => e.preventDefault()}>
          <textarea placeholder='Message channel' />
        </form>
      </footer>
    </div>
  )
}

const mapStateToProps = ({ chat: { id, title } }) => ({ id, title })

export default connect(mapStateToProps)(ChatArea)
